export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/kevin-profile-068576a54b8e13fc4f70179456368c37.png";